<template>
  <div id="privacy-policy-page">
    <div class="background-header d-flex justify-center">
      <v-img
        src="/img/pdpa/logo-pdpa.webp"
        width="250"
        height="250"
        contain
        class="logo"
      />
    </div>

    <div class="container">
      <div class="text-center">
        <h1>
          นโยบายเกี่ยวกับคุกกี้ (Cookies Policy)
        </h1>
      </div>

      <!-- 1. คุกกี้คืออะไร -->
      <div>
        <p class="font-weight-bold">
          1. คุกกี้คืออะไร
        </p>
        <p class="text-indent">
          คุกกี้ คือ ไฟล์ขนาดเล็กที่เก็บไว้บนเบราว์เซอร์ของผู้ใช้บริการหรือบนฮาร์ดไดร์ฟในคอมพิวเตอร์
          หรืออุปกรณ์มือถือของผู้ใช้บริการซึ่งทำหน้าที่บันทึกข้อมูลและการตั้งค่า
          ต่าง ๆ เช่น บันทึกข้อมูลการตั้งค่าภาษาในเบราว์เซอร์บนอุปกรณ์ของผู้ใช้บริการ
          บันทึกสถานะการเข้าใช้งานในปัจจุบันของผู้ใช้บริการ เพื่อช่วยให้ผู้ใช้บริการสามารถเข้าใช้งาน
          เว็บไซต์ได้อย่างต่อเนื่อง รวมถึงมีการรวบรวมข้อมูลเกี่ยวกับประวัติการเข้าชมเว็บไซต์
          ที่ผู้ใช้บริการชื่นชอบในรูปแบบไฟล์ โดยคุกกี้ไม่ได้ทำให้เกิดอันตรายต่ออุปกรณ์ของคุณ
          และเนื้อหาในคุกกี้จะถูกเรียกออกมาดูหรืออ่านได้โดยเว็บไซต์ที่สร้างคุกกี้ดังกล่าวเท่านั้น
          คุณสามารถยอมรับหรือปฏิเสธการใช้งานคุกกี้ได้โดยการปรับการตั้งค่าในเบราว์เซอร์
          ของคุณ หากคุณต้องการทำเช่นนี้ โปรดดูที่เมนูช่วยเหลือของเบราว์เซอร์ของคุณ
        </p>
        <p class="text-indent">
          ข้อมูลที่เราได้รับผ่านคุกกี้และเทคโนโลยีที่คล้ายคลึงกัน ในที่นี้ยังอาจรวมถึง IP address
          ของคุณ รหัสโฆษณาบนมือถือ, คุณลักษณะของเบราว์เซอร์, คุณลักษณะ
          อุปกรณ์, รหัสอุปกรณ์เฉพาะ, ระบบปฏิบัติการ, การตั้งค่าภาษา, การอ้างอิง URL,
          บันทึกพฤติกรรมบนเว็บไซต์ของคุณ อย่างเช่นเนื้อหาที่ผู้ใช้บริการเข้าชมหรือสนใจขณะที่ทำ
          การเยี่ยมชมเว็บไซต์นั้น ๆ รวมถึงวันที่และเวลาที่ผู้ใช้บริการเข้าถึงหรือใช้งานเว็บไซต์
          ในการเชื่อมต่อแอพบนมือถือและแท็บเล็ตเราอาจใช้วิธีการอัตโนมัติที่คล้ายกันด้วยนโยบาย
          คุ้มครองข้อมูลส่วนบุคคลของเรา จะกำหนดรายละเอียดทั้งหมดเกี่ยวกับข้อมูลอื่น ๆ
          ที่เราจัดเก็บและวิธีการที่เรานำข้อมูลส่วนตัวของคุณไปใช้
        </p>
      </div>

      <!-- 2. ประเภทคุกกี้ -->
      <div class="cookie-type">
        <p class="font-weight-bold">
          2. ประเภทคุกกี้
        </p>
        <p class="text-indent text-dot">
          คุกกี้ที่จำเป็นสำหรับการทำงานของเว็บไซต์ (Strictly Necessary Cookies)
          คือ คุกกี้ที่มีความจำเป็นต่อการทำงานของเว็บไซต์ เพื่อให้เว็บไซต์สามารถทำงาน
          ได้เป็นปกติ มีความปลอดภัย และทำให้ท่านสามารถเข้าใช้เว็บไซต์ได้ เช่น การ log in
          เข้าสู่เว็บไซต์ การยืนยันตัวตน ทั้งนี้ ท่านไม่สามารถปิดการใช้งานของคุกกี้ประเภทนี้ผ่าน
          ระบบของเว็บไซต์ของเราได้
        </p>
        <!-- <p class="text-indent text-dot">
          คุกกี้เพื่อปรับเนื้อหาเข้ากับกลุ่มเป้าหมาย (Targeting Cookies)
          คือ คุกกี้ที่จะบันทึกการเข้าชมเว็บไซต์ของท่าน หน้าเว็บที่ท่านได้เยี่ยมชม
          และลิงค์ที่ท่านเยี่ยมชม
          เราจะใช้ข้อมูลนี้เพื่อปรับให้เว็บไซต์และเนื้อหาใด ๆ ที่ปรากฏอยู่บนหน้าเว็บตรงกับ
          ความสนใจของคุณมากขึ้น นอกจากนี้ เรายังอาจแชร์ข้อมูลนี้กับบุคคลที่สามเพื่อวัตถุประสงค์
          ดังกล่าว
        </p> -->
        <p class="text-indent text-dot">
          คุกกี้ด้านประสิทธิภาพการทำงานของเว็บไซต์ (Performance Cookies)
          คือ คุกกี้เพื่อให้เข้าใจว่าผู้ใช้งานเช่นท่าน มีปฏิสัมพันธ์กับเว็บไซต์ฯ อย่างไร โดยให้
          ข้อมูลเกี่ยวกับพื้นที่ ซึ่งมีการเข้าชมเว็บ เวลาที่ใช้ และประเด็นอื่นๆ ที่เกี่ยวข้อง
          เช่น ข้อผิดพลาดต่างๆ  คุกกี้ประเภทนี้จะไม่ระบุตัวตนของท่านได้ และข้อมูลที่ได้มาจะไม่สามารถ
          ระบุตัวตนได้
        </p>
        <p class="text-indent text-dot">
          คุกกี้เพื่อการโฆษณา (Advertising Cookies) คือ คุกกี้ที่จะจดจำการตั้งค่าของ
          ท่านในการเข้าใช้งานหน้าเว็บไซต์ และนำไปใช้เป็นข้อมูลประกอบการปรับเปลี่ยน
          หน้าเว็บไซต์เพื่อนำเสนอโฆษณาที่เหมาะสมกับท่านมากที่สุดเท่าที่จะเป็นไปได้
          ตัวอย่างเช่น การเลือกแสดงโฆษณาสินค้าที่ท่านสนใจ การป้องกันหรือการจำกัดจำนวนครั้งที่ท่าน
          จะเห็นหน้าเว็บไซต์ของโฆษณาซ้ำๆ  เพื่อช่วยวัดความมีประสิทธิผลของโฆษณา
        </p>
      </div>

      <!-- 3. ใช้คุกกี้อะไรบ้าง -->
      <div>
        <p class="font-weight-bold">
          3. ใช้คุกกี้อะไรบ้าง
        </p>
        <div class="container-table-cookie">
          <table class="table-cookie">
            <thead>
              <tr>
                <th
                  v-for="(header, index) in headers"
                  :key="index"
                  class="text-center">
                  {{ header.text }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item,index) in items"
                :key="index"
              >
                <td
                  v-for="(child, childIndex) in item.data"
                  :key="childIndex"
                  :rowspan="(item.index === 0 && childIndex === 0) ? item.rowspan : 1"
                >
                  {{ child }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 4. ระยะเวลาในการจัดเก็บคุกกี้ -->
      <div>
        <p class="font-weight-bold">
          4. ระยะเวลาในการจัดเก็บคุกกี้
        </p>
        <p>
          มีคุกกี้ 2 ประเภทที่ถูกจัดเก็บไว้
        </p>
        <p class="text-indent text-dot">
          คุกกี้แบบช่วงเวลา (Session Cookies) จะถูกลบโดยอัตโนมัติเมื่อคุณปิดเบราว์เซอร์
        </p>
        <p class="text-indent text-dot">
          คุกกี้ถาวร (Persistent Cookies) จะยังคงอยู่ในเครื่องคอมพิวเตอร์ของผู้ใช้บริการ
          จนกระทั่งหมดอายุหรือถูกลบทิ้ง Persistent cookies สามารถ
          เก็บข้อมูลความสนใจของผู้ใช้บริการทำให้การเข้าใช้เว็บไซต์ครั้งต่อๆ ไปของผู้ใช้บริการง่าย
          และใกล้เคียงกับความสนใจของผู้ใช้บริการมากขึ้น
        </p>
      </div>

      <!-- 5. ทางเลือกเกี่ยวกับคุกกี้ -->
      <div>
        <p class="font-weight-bold">
          5. ทางเลือกเกี่ยวกับคุกกี้
        </p>
        <p class="text-indent">
          ในกรณีที่คุณไม่ประสงค์ให้มีการเก็บรวบรวมข้อมูลของผู้ใช้บริการผ่านทางคุกกี้ และซอฟท์แวร์
          และเครื่องมือการตรวจวัด ผู้ใช้บริการสามารถลบหรือปฏิเสธคุกกี้
          หรือซอฟท์แวร์การตรวจวัดบางรายการผ่านทางบราวเซอร์ หรือหมวดการตั้งค่าในอุปกรณ์มือถือ
          หรือแท็บเล็ตของคุณได้ ทั้งนี้ขอเรียนว่าหากคุณปิดการใช้งานคุกกี้หรือเอา
          คุกกี้ออกไปนั้น คุณลักษณะของบางอย่าง เว็บไซต์อาจจะไม่ทำงานตามวัตถุประสงค์ที่กำหนดไว้
          เช่น คุณอาจจะไม่สามารถเข้าเยี่ยมพื้นที่บางส่วนของเว็บไซต์หรือคุณอาจจะ
          ไม่ได้รับข้อมูลที่จัดให้เป็นการเฉพาะตัวเมื่อคุณเยี่ยมชมเว็บไซต์
        </p>
        <p class="text-indent">
          หากผู้ใช้บริการใช้อุปกรณ์ต่างกันในการเปิดดูและเข้ามายังเว็บไซต์ (เช่น คอมพิวเตอร์
          สมาร์ทโฟน แท็บเล็ต) คุณจะต้องดำเนินการเพื่อปรับแต่ละบราวเซอร์
          (Browser) ในแต่ละอุปกรณ์นั้นเพื่อให้สอดคล้องกับ Cookie Preferences ของคุณเอง
        </p>
        <p class="text-indent">
          คุณสามารถจัดการคุกกี้ในเบราว์เซอร์ของท่านได้โดยการตั้งค่า ดังนี้
        </p>
        <p class="text-indent text-dot">
          Cookies settings in
          <a
            href="https://support.google.com/chrome/answer/95647"
            target="_blank"
            class="text-link">
            Chrome
          </a>
        </p>
        <p class="text-indent text-dot">
          Cookies settings in
          <a
            href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer"
            target="_blank"
            class="text-link">
            Firefox
          </a>
        </p>
        <p class="text-indent text-dot">
          Cookies settings in
          <a
            href="https://support.apple.com/th-th/guide/safari/sfri11471/mac"
            target="_blank"
            class="text-link">
            Safari
          </a>
          and
          <a
            href="https://support.apple.com/th-th/HT201265"
            target="_blank"
            class="text-link">
            iOS
          </a>
        </p>
        <p class="text-indent text-dot">
          Cookies settings in
          <a
            href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
            target="_blank"
            class="text-link">
            Internet Explorer
          </a>
        </p>
        <p class="text-indent text-dot">
          Cookies settings in
          <a
            href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
            target="_blank"
            class="text-link">
            Microsoft Edge
          </a>
        </p>
      </div>

      <!-- 6. ช่องทางการติดต่อบริษัท -->
      <div>
        <p class="font-weight-bold">
          6. ช่องทางการติดต่อบริษัท
        </p>
        <p>
          บริษัท เซลสุกิ จำกัด
        </p>
        <p>
          10/39 ชั้นที่ 3 ถนนรัชดาภิเษก แขวงจันทรเกษม เขตจตุจักร กรุงเทพมหานคร
          10900 หรือติดต่อผ่าน แผนกคุ้มครองข้อมูลส่วนบุคคล (Data Protection
          Office Unit)
        </p>
        <p>
          Email: lineagency@sellsuki.com
        </p>
      </div>

      <!-- 7. การเปลี่ยนแปลงนโยบายคุกกี้ -->
      <div>
        <p class="font-weight-bold">
          7. การเปลี่ยนแปลงนโยบายคุกกี้
        </p>
        <p>
          เราอาจปรับปรุงนโยบายการใช้คุกกี้นี้และเราขอส่งเสริมให้คุณทบทวนนโยบายนี้เป็นระยะ ๆ
          เพื่อรับทราบถึงวิธีการใช้คุกกี้ของเรา
        </p>
      </div>

      <div>
        <p>
          นโยบายการใช้คุกกี้นี้ได้รับการปรับปรุงล่าสุดเมื่อวันที่ 5 พฤษภาคม 2565
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookiePolicyPage',
  computed: {
    headers () {
      return [
        { text: 'ประเภทคุกกี้' },
        { text: 'ชื่อคุกกี้' },
        { text: 'Provider' },
        { text: 'วัตถุประสงค์คุกกี้' }
      ]
    },
    items () {
      return [
        {
          text: 'คุกกี้ที่จำเป็นสำหรับการทำงานของเว็บไซต์ (Strictly Necessary Cookies)',
          children: [
            ['PHPSESSID', 'Sellsuki', 'ใช้เพื่อบันทึกการใช้เว็บไซต์ระหว่างเซสชั่น คุกกี้นี้ไม่มีข้อมูลส่วนบุคคล'],
            ['__cfduid', 'Cloudflare', 'ใช้ตรวจสอบแหล่งการใช้งานของผู้ใช้ว่ามาจากแหล่งที่ปลอดภัย']
          ]
        },
        // {
        //   text: 'คุกกี้เพื่อปรับเนื้อหาเข้ากับกลุ่มเป้าหมาย (Targeting Cookies)',
        //   children: []
        // },
        {
          text: 'คุกกี้ด้านประสิทธิภาพการทำงานของเว็บไซต์ (Performance Cookies)',
          children: [
            ['gtm_debug, gtm_auth, gtm_preview, _gcl_aw', 'Google Tag Manager', 'ใช้สำหรับเก็บพฤติกรรมการใช้งานในเว็บไซต์ เพื่อนำไปปรับปรุงผลิตภัณฑ์และเว็บไซต์ให้มีประสิทธิภาพยิ่งขึ้น'],
            ['_hjid, __hs*, hubspotutk, _hjIncludedInSample', 'Hotjar', 'ใช้สำหรับเก็บพฤติกรรมการใช้งานในเว็บไซต์ เพื่อนำไปปรับปรุงผลิตภัณฑ์และเว็บไซต์ให้มีประสิทธิภาพยิ่งขึ้น'],
            ['_ga, _gid, _gat, _gac_UA-*', 'Google Analytic', 'ใช้สำหรับเก็บพฤติกรรมการใช้งานในเว็บไซต์ เพื่อนำไปปรับปรุงผลิตภัณฑ์และเว็บไซต์ให้มีประสิทธิภาพยิ่งขึ้น']
          ]
        },
        {
          text: 'คุกกี้เพื่อการโฆษณา (Advertising Cookies)',
          children: [
            ['external_id', 'Sellsuki', 'ใช้สำหรับเก็บพฤติกรรมการใช้งานของผู้ใช้เพื่อส่งให้กับบุคคลที่สาม คุกกี้นี้ไม่สามารถระบุตัวตนของผู้ใช้ได้'],
            ['IDE,DSID', 'DoubleClick', 'ใช้สำหรับการโฆษณาผ่านทาง Google Adwords ทำให้ Google Adwords นำเสนอผลิตภัณฑ์ให้เหมาะกับผู้ใช้งานมากขึ้น'],
            ['fr, _fbp, _fbc', 'Facebook', 'ใช้สำหรับการโฆษณาผ่านทาง Facebook ทำให้ Facebook นำเสนอผลิตภัณฑ์ให้เหมาะกับผู้ใช้งานมากขึ้น'],
            ['bcookie, lang, lidc, lissc, li_sugr, UserMatchHistory', 'Linkedin', 'ใช้สำหรับประกาศรับสมัครงานทาง Linkedin']
          ]
        }
      ].reduce((acc, cur) => {
        const array = cur.children.map((item, index) => {
          const data = index ? item : [cur.text, ...item]
          return {
            index,
            rowspan: cur.children.length,
            data
          }
        })
        acc.push(...array)
        return acc
      }, [])
    }
  }
}
</script>

<style lang="scss" scoped>
#privacy-policy-page {
    background-color: #E5E5E5;

    > .background-header {
        height: 200px;
        background-color: #2C395A;

        > .logo {
            z-index: 1;
        }
    }

    > .container {
        background-color: #FFFFFF;
        border-radius: 20px 20px 0px 0px;
        margin-top: -50px;
        padding: 30px;
        padding-top: 90px;

        > div {
            line-height: 30px;
            margin-bottom: 50px;

            > h1 {
                font-size: 36px;
                line-height: 54px;
                margin-bottom: 20px;
            }

            p , span{
                margin-bottom: 0px;

                &.text-indent {
                  text-indent: 50px;
                }

                &.text-dot::before {
                  content: '\2022';
                  margin-right: 10px;
                }

                &.text-link {
                  color: #4196EC;
                  text-decoration: underline;
                }
            }

            .container-table-cookie {
                overflow-x: auto;

                > .table-cookie {
                    width: 100%;
                    border-collapse: collapse;

                    th {
                        border: 1px solid #000000;
                        background-color: #000000;
                        color: #FFFFFF;
                        padding: 10px;
                    }

                    td {
                        border: 1px solid #000000;
                        padding: 10px;
                    }
                }
            }
        }
    }
}

@media only screen and (max-width: 600px) {
    #privacy-policy-page {
        > .background-header {
            > .logo {
                margin-top: 50px;
            }
        }

        > .container {
            margin-top: 40px;
            padding-top: 50px;

            > div {
                > h1 {
                    font-size: 30px;
                    line-height: 45px;
                }

                .container-table-cookie {
                    > .table-cookie {
                        table-layout: fixed;
                        width: 800px;

                        th {
                            border: 1px solid #000000;
                            background-color: #000000;
                            color: #FFFFFF;
                            padding: 10px;
                        }

                        td {
                            border: 1px solid #000000;
                            padding: 10px;
                        }
                    }
                }
            }
        }
    }
}
</style>
